export default "__VITE_ASSET__HAWFmOYs__"